module.exports = __webpack_public_path__ + "img/display.bce53e49.svg";